/**
 * Twitter Web Intent URLを生成するユーティリティ
 */

export interface TweetData {
  totalTime: number;  // ミリ秒
  roundNumber: number;
  penaltyTime: number;  // ミリ秒
  gameUrl?: string;
}

export class TwitterShare {
  /**
   * ゲームクリア時のツイート内容を生成
   */
  static generateTweetText(data: TweetData): string {
    const { totalTime, roundNumber, penaltyTime } = data;

    // 時間をフォーマット
    const totalSecondsFloat = totalTime / 1000;
    const minutes = Math.floor(totalSecondsFloat / 60);
    const seconds = (totalSecondsFloat % 60).toFixed(1);
    const timeText = minutes > 0 ? `${minutes}分${seconds}秒` : `${seconds}秒`;

    // ペナルティがあるか
    const hasPenalty = penaltyTime > 0;
    const penaltyText = hasPenalty ? ` (ペナルティ+${(penaltyTime / 1000).toFixed(0)}秒)` : '';

    // ツイート本文
    let text = `チムドンミニ 全${roundNumber}ラウンドクリア！🎉\n`;
    text += `⏱️ タイム: ${timeText}${penaltyText}\n`;

    // 時間に応じたメッセージ
    if (totalSecondsFloat < 300) {  // 5分未満
      text += `🏆 超高速クリア！すごい！`;
    } else if (totalSecondsFloat < 600) {  // 10分未満
      text += `🌟 素晴らしいタイム！`;
    } else if (totalSecondsFloat < 900) {  // 15分未満
      text += `👏 お見事！`;
    } else {
      text += `🎮 クリアおめでとう！`;
    }

    return text;
  }

  /**
   * Twitter Web Intent URLを生成
   */
  static generateTweetUrl(data: TweetData): string {
    const text = this.generateTweetText(data);
    const gameUrl = data.gameUrl || window.location.href.split('?')[0];  // クエリパラメータを除去
    const hashtags = 'チムドンミニ,パズルゲーム';

    // URLエンコード
    const encodedText = encodeURIComponent(text);
    const encodedUrl = encodeURIComponent(gameUrl);
    const encodedHashtags = encodeURIComponent(hashtags);

    return `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}&hashtags=${encodedHashtags}`;
  }

  /**
   * Twitterシェアウィンドウを開く
   */
  static openTweetWindow(data: TweetData): void {
    const url = this.generateTweetUrl(data);
    const width = 550;
    const height = 420;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    window.open(
      url,
      'twitter-share',
      `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,status=no`
    );
  }
}
